import { z } from 'zod';
import {
    mockSnapshot,
    Snapshot,
    snapshotSchema,
} from 'app/agriculture/queries/snapshots/types/Snapshot';
import { MapLocation, mapLocationSchema } from 'app/agriculture/queries/types/MapLocation';

export interface ProtagAnimalSnapshot extends Snapshot {
    location: MapLocation | null;

    batteryVoltage: number | null;
    solarVoltage: number | null;
    earTemperature: number | null;
    ambientTemperature: number | null;
}

export const protagAnimalSnapshotSchema = snapshotSchema.extend({
    location: mapLocationSchema.nullable(),

    batteryVoltage: z.number().nullable(),
    solarVoltage: z.number().nullable(),
    earTemperature: z.number().nullable(),
    ambientTemperature: z.number().nullable(),
});

export const mockProtagAnimalSnapshot = ({
    location = { latitude: 0, longitude: 0 },

    batteryVoltage = 111,
    solarVoltage = 222,
    earTemperature = 333,
    ambientTemperature = 444,

    ...snapshot
}: Partial<ProtagAnimalSnapshot> = {}): ProtagAnimalSnapshot => ({
    ...mockSnapshot(snapshot),

    location,

    batteryVoltage,
    solarVoltage,
    earTemperature,
    ambientTemperature,
});
